import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import Image from 'UIKit/Image'
import Text from 'UIKit/Text'
import { SidebarFeatureEnum } from 'config/types/sidebar'
import { RowBetween } from 'layout/Components/Row'
import { Trans } from 'react-i18next'
import { useAppDispatch } from 'state'
import { setMenuOpen } from 'state/app/actions'
import { useToggleSidebar } from 'state/app/hooks'
import { useTournamentList } from 'state/tournament/hooks'
import { StyledExtendMenuItem, StyledTitle } from '../../style'

const TournamentMenu = () => {
  const { activeTournaments } = useTournamentList()
  const { openSidebar } = useToggleSidebar()
  const dispatch = useAppDispatch()

  return (
    <StyledExtendMenuItem
      id="menu-bonusCenter"
      onClick={() => {
        dispatch(setMenuOpen({ isOpen: false }))
        openSidebar(SidebarFeatureEnum.Tournament)
      }}
      mt="4px"
      borderRadius="8px"
      overflow="hidden"
      position="relative"
    >
      <RowBetween width="100%" top="0px" position="absolute" px="8px">
        <Flex justifyContent="center" alignItems="center" height="44px">
          <Box position="relative" width="20px">
            <Image src="/images/tournament/tournament-icon.png" width={60} height={60} alt="tournament-icon" />
          </Box>
          <Flex flexDirection="column" ml="8px">
            <StyledTitle fontSize="14px !important" color="textTertiary" fontWeight={500}>
              <Trans>Tournament</Trans>
            </StyledTitle>
          </Flex>
        </Flex>

        <Text color="textAlt1" fontSize="12px" fontWeight={600} minWidth="18px" textAlign="center">
          {activeTournaments.length || ''}
        </Text>
      </RowBetween>
    </StyledExtendMenuItem>
  )
}

export default TournamentMenu
